import React from 'react';
import { Box, Link, Typography, Button, SvgIcon } from '@mui/material';
import { Formik, Form } from 'formik';
import { SignInData } from 'Types';
import SignInForm, { signInFormSchema } from 'Components/Forms/SignInForm';
import { ValidateForm } from 'Utils/Forms';
// import { Auth } from 'aws-amplify';
import { ReactComponent as GoogleIcon } from 'assets/images/Google__G__Logo.svg';
import { MUSEFLOW_OFF_WHITE_1, MUSEFLOW_OFF_WHITE_3 } from 'Components/Colors';
import { isPhoneNumber, isEmail } from 'Components/Forms/SignUpForm';
import { useNavigate } from 'react-router-dom';
import { hasAuthParams } from 'react-oidc-context';
import { SetErrorsPayload, useAuthWrapperContext } from 'Contexts/AuthWrapperContext';
import { CustomCircularProgress } from 'Components/StyledComponents';

type SignInProps = {
  forgotPasswordNavFunction: () => void;
  goBackFn: () => void;
};

const SignIn: React.FC<SignInProps> = (props) => {
  const [_isIpad, _setIsIpad] = React.useState(false);
  const _navigate = useNavigate();
  const { forgotPasswordNavFunction } = props;
  const {
    pendingEmailOrPhone,
    errors,
    logInUsername,
    resendSignUpUsername,
    resetErrors,
    logInOidc,
    isLoading,
    oauthPending,
  } = useAuthWrapperContext();

  // Only show spinner if path doesn't include 'logout' (logout has auth params but shouldn't show spinner)
  const isOAuthLoginCallback = hasAuthParams();

  const [formErrors, setFormErrors] = React.useState<SetErrorsPayload | object>({});

  React.useEffect(() => {
    console.log('setting form errors:', errors);
    setFormErrors(errors);
  }, [errors]);

  console.log('window.location.origin:', window.location.origin);

  return (
    <>
      {console.log('isLoading:', isLoading)}
      {(isLoading || oauthPending || isOAuthLoginCallback) && (
        <Box>
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 9999,
            }}
          >
            <CustomCircularProgress />
          </Box>
        </Box>
      )}

      <h3 className="title-welcome" style={{ marginTop: '50px' }}>
        Welcome to MuseFlow!
      </h3>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '20px',
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
            color: MUSEFLOW_OFF_WHITE_1,
            paddingBottom: '14px',
            ...textStyles,
            fontSize: '15px',
          }}
        >
          Sign in with:
        </Box>
        {/* <Box sx={{...textStyles,color: MUSEFLOW_OFF_WHITE_1,marginBottom: '10px'}}>isCapacitorNative(): {isCapacitorNative() ? "Yes" : "No"}</Box>
      <Box sx={{...textStyles,color: MUSEFLOW_OFF_WHITE_1,marginBottom: '10px'}}>isIosTablet(): {isIosTablet() ? "Yes" : "No"}</Box>
      <Box sx={{...textStyles,color: MUSEFLOW_OFF_WHITE_1,marginBottom: '10px'}}>window.innerWidth: {window.innerWidth}</Box>
      <Box sx={{...textStyles,color: MUSEFLOW_OFF_WHITE_1,marginBottom: '10px'}}>window.innerHeight: {window.innerHeight}</Box>
      <Box sx={{...textStyles,color: MUSEFLOW_OFF_WHITE_1,marginBottom: '10px'}}>window.agent: {window.navigator.userAgent}</Box>
      <Box sx={{...textStyles,color: MUSEFLOW_OFF_WHITE_1,marginBottom: '10px'}}>{"window.innerWidth >= 1000 && window.innerHeight < 1000"}: {(window.innerWidth >= 1000 && window.innerHeight < 1000) ? "yes" : "no"}</Box>
      <Box sx={{...textStyles,color: MUSEFLOW_OFF_WHITE_1,marginBottom: '10px'}}>Is an ipad: {isIosTablet() && !isCapacitorNative() && ((window.innerWidth >= 1100 && window.innerHeight < 1100) || (window.innerWidth < 1100 && window.innerHeight >= 1100)) ? "Yes" : "No"}</Box> */}

        <Box
          sx={{
            // width:'80%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              gap: '5px',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '200px',
            }}
          >
            <Button
              sx={{
                minWidth: '162px',
                fontSize: '16px',
                color: MUSEFLOW_OFF_WHITE_1,
                borderStyle: 'solid',
                borderColor: MUSEFLOW_OFF_WHITE_1,
                borderRadius: '40px',
                borderWidth: '2px',
                padding: '8px 40px',
                marginRight: '4px',
              }}
              onClick={async () => {
                await logInOidc('Google');
              }}
              startIcon={
                <SvgIcon>
                  <GoogleIcon />
                </SvgIcon>
              }
            >
              Google
            </Button>

            <Button
              sx={{
                fontSize: '16px',
                color: MUSEFLOW_OFF_WHITE_1,
                borderStyle: 'solid',
                borderColor: MUSEFLOW_OFF_WHITE_1,
                borderRadius: '40px',
                borderWidth: '2px',
                padding: '8px 40px',
                marginRight: '4px',
              }}
              onClick={async () => {
                await logInOidc('SignInWithApple');
              }}
              startIcon={
                <SvgIcon>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                </SvgIcon>
              }
            >
              Apple
            </Button>
          </Box>
          <Box
            sx={{
              display: 'flex',
              width: '350px',
              alignItems: 'center',
              paddingTop: '20px',
              paddingBottom: '20px',
            }}
          >
            <Box
              sx={{
                height: '0px',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: MUSEFLOW_OFF_WHITE_3,
                width: '100%',
              }}
            />
            <Typography
              sx={{
                paddingLeft: '10px',
                paddingRight: '10px',
                color: MUSEFLOW_OFF_WHITE_3,
              }}
            >
              or
            </Typography>
            <Box
              sx={{
                height: '0px',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: MUSEFLOW_OFF_WHITE_3,
                width: '100%',
              }}
            />
          </Box>

          {pendingEmailOrPhone && isEmail(pendingEmailOrPhone) && (
            <Box sx={{ paddingBottom: '20px' }}>
              <Typography
                sx={{
                  marginBottom: '20px',
                  padding: '10px',
                  borderRadius: '4px',
                  backgroundColor: 'rgba(57, 94, 227, 0.40)',
                }}
                color="#00C2FF"
              >
                Your registration is pending. Check your email to verify.
                <br></br>
                (If you don't see an email, check your spam folder)
              </Typography>
              <Link
                sx={{
                  textAlign: 'center' as const,
                  cursor: 'pointer',
                  marginBottom: '10px',
                }}
                onClick={() => {
                  resendSignUpUsername(pendingEmailOrPhone || '');
                }}
              >
                Didn't get a link? Click here to resend.
              </Link>
            </Box>
          )}

          {pendingEmailOrPhone && isPhoneNumber(pendingEmailOrPhone) && (
            <Typography
              sx={{
                marginBottom: '20px',
                padding: '10px',
                borderRadius: '4px',
                backgroundColor: 'rgba(57, 94, 227, 0.40)',
              }}
              color="#00C2FF"
            >
              Your verification is pending.<br></br>Check your text messages for a verification
              code.
            </Typography>
          )}

          <Formik
            initialValues={{
              emailOrPhone: '',
              password: '',
              unknown: '',
              countryAcronym: 'US',
            }}
            validate={(values: SignInData) => {
              return ValidateForm(signInFormSchema, values);
            }}
            onSubmit={async (values, _formikHelpers) => {
              await logInUsername(values.emailOrPhone, values.password, values.countryAcronym);
            }}
            validateOnChange={false}
          >
            {(formikProps) => (
              <Form
                onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                  e.preventDefault();
                  resetErrors();
                  formikProps.handleSubmit(e);
                }}
              >
                <Box sx={{ width: '350px', display: 'flex', flexDirection: 'column' }}>
                  <SignInForm
                    forgotPasswordNavFunction={forgotPasswordNavFunction}
                    {...formikProps}
                    errors={{ ...formErrors, ...formikProps.errors }}
                  />
                </Box>
              </Form>
            )}
          </Formik>
          <Box
            sx={{
              color: MUSEFLOW_OFF_WHITE_1,
              marginTop: '20px',
              marginBottom: '24px',
              ...textStyles,
            }}
          >
            Don't have an account? &nbsp;{' '}
            <Link href={'/register'} sx={{ color: '#6F87F1' }}>
              {' '}
              Create an account
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  );
};

const textStyles = {
  fontFamily: 'Lato',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
  letterSpacing: '0.16px',
};

export default SignIn;
